<template>
  <div class="col-12 no-gutters container mt-3">
    <div class="e-chart-container">
      <div class="title-and-chart">
        <div :id="eChartId" class="e-chart">
          <chart :options="options"></chart>
        </div>
        <div :id="eChartMiniId">
          <img :src="imageUrl" class="pdf-content-image-width hidden-dashboard-display"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EChartsMixins from "../../mixins/EChartsMixins";
import BarHorizontalService from "../../services/echarts/bar.horizontal.service";
import SymbolService from "../../services/symbol.service";
import $ from "jquery";

export default {
  name: "SalesWizardChart",
  mixins: [EChartsMixins],
  props: {
    eChartId: {
      type: String,
      default: "sales-wizard-chart"
    },
    eChartMiniId: {
      type: String,
      default: "sales-wizard-chart-mini"
    },
    inputReportTypeName: {
      type: String,
      default: "Chart - Sales Wizard"
    },
    modalId: {
      type: String,
      default: "sales-wizard-chart"
    },
    isSavedCard: {
      type: Boolean,
      default: false
    },
    inputClientChart: {
      type: Object,
      default: () => ({})
    },
    clientId: {
      type: Number,
      default: 0
    },
    inputDownloadFileName: {
      type: String,
      default: "Sales Wizard"
    },
    inputSalesWizardData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      charts: [],
      imageUrl: "",
      options: {
        title: { text: '' },
        tooltip: {},
        grid: { containLabel: true },
        xAxis: { type: 'value' },
        yAxis: { type: 'category', data: [] },
        series: []
      }
    };
  },
  methods: {
    getChartOptions: function(){
        return this.options;           
    },
    setData(data) {
      if (!data) return;
      if (data.rows) {
        this.options = this.buildSalesWizardOptions(data);
        return;
      }
      if (data.options) {
        this.options = { ...this.options, ...data.options };
      } else {
        this.options = { ...this.options, ...data };
      }
    },
    getSalesWizardStyles() {
      return [
        {
          key: "charismatics",
          name: "Charismatics",
          color: "#163E64",
          symbol: SymbolService.getCharismaticsSymbol()
        },
        {
          key: "thinkers",
          name: "Thinkers",
          color: "#A6CAEC",
          symbol: SymbolService.getThinkersSymbol()
        },
        {
          key: "skeptics",
          name: "Skeptics",
          color: "#DCEAF7",
          symbol: SymbolService.getSkepticsSymbol()
        },
        {
          key: "prudents",
          name: "Prudents",
          color: "#4E95D9",
          symbol: SymbolService.getPrudentsSymbol()
        },
        {
          key: "controllers",
          name: "Controllers",
          color: "#0E2841",
          symbol: SymbolService.getControllersSymbol()
        }
      ];
    },
    buildSalesWizardOptions(data) {
      const styles = this.getSalesWizardStyles();
      const rows = data.rows || [];
      const rowNames = rows.map(row => row.name);
      const darkStyleKeys = ["charismatics", "controllers"];
      const rowBorderLines = Array.from({ length: rows.length + 1 }, (value, index) => ({
        yAxis: index - 0.5
      }));
      const legendData = styles.map(style => style.name);
      const seriesData = styles.map(style => ({
        name: style.name,
        data: rows.map(row => row[style.key] || 0)
      }));

      BarHorizontalService.setBarWidth(70);
      BarHorizontalService.setShowSnap(this.isSavedCard);
      BarHorizontalService.setShowToolbox(false);
      BarHorizontalService.setShowLabel(true);
      BarHorizontalService.setShowLegend(true);
      BarHorizontalService.setShowTooltip(true);
      BarHorizontalService.setIsMultiWave(rows.length > 1);
      BarHorizontalService.setChartType("stacked-bar-horizontal");
      BarHorizontalService.setLegendData(legendData);
      BarHorizontalService.setSeriesData(seriesData);
      BarHorizontalService.setYAxisData(rowNames);

      let options = BarHorizontalService.getOptions(
        false,
        true,
        this,
        this.modalId,
        this.inputReportTypeName,
        rows.length,
        this.inputDownloadFileName
      );

      $.extend(true, options, {
        color: styles.map(style => style.color),
        animation: false,
        title: {
          text: "",
          show: false
        },
        tooltip: {
          trigger: "item",
          formatter: params => {
            if (params.seriesType === "pictorialBar") {
              return params.name;
            }
            return `${params.name}<br/>${params.seriesName}: ${Number(params.value).toFixed(1)}%`;
          }
        },
        legend: {
          orient: "vertical",
          right: 48,
          left: null,
          top: 72,
          icon: "bar",
          itemWidth: 8,
          itemHeight: 8,
          borderWidth: 0,
          width: null,
          textStyle: {
            color: "#000",
            fontSize: 11,
            fontFamily: "Franklin Gothic Medium Cond"
          },
          data: legendData
        },
        grid: [
          {
            left: 118,
            right: 178,
            top: 78,
            bottom: 36,
            backgroundColor: "#F8F8F8",
            containLabel: false,
            show: true
          },
          {
            left: 118,
            right: 178,
            top: 28,
            height: 30,
            containLabel: false,
            show: true,
            borderWidth:0
          }
        ],
        xAxis: [
          {
            type: "value",
            gridIndex: 0,
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: "{value}%",
              color: "#000000",
              fontSize: 10,
              fontWeight: 700
            },
            axisTick: { show: false },
            axisLine: {
              lineStyle: { color: "#8a8a8a" }
            },
            splitLine: {
              lineStyle: { color: "#fff" }
            }
          },
          {
            type: "category",
            gridIndex: 1,
            boundaryGap: true,
            data: styles.map(style => style.name),
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: { show: false },
            splitLine: { show: false }
          }
        ],
        yAxis: [
          {
            type: "category",
            gridIndex: 0,
            inverse: true,  
            data: rowNames,
            axisLine: {
              lineStyle: { color: "#8a8a8a" }
            },
            axisTick: { show: false },
            axisLabel: {
              color: "#000000",
              fontSize: 10,
              fontWeight: 700,
              margin: 8
            }
          },
          {
            type: "value",
            gridIndex: 1,
            min: 0,
            max: 1,
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: { show: false },
            splitLine: { show: false }
          }
        ],
        series: this.getSalesWizardSeries(options.series, styles, rows, darkStyleKeys, rowBorderLines)
      });
      options.toolbox.show = true;
      return options;
    },
    getSalesWizardSeries(baseSeries, styles, rows, darkStyleKeys, rowBorderLines) {
      const barSeries = baseSeries.map((series, index) => {
        const style = styles[index];
        let salesWizardBarSeries = {};
        $.extend(true, salesWizardBarSeries, series, {
          stack: "sales-wizard",
          xAxisIndex: 0,
          yAxisIndex: 0,
          barWidth: 70,
          itemStyle: {
            color: style.color
          },
          label: {
            show: true,
            position: "inside",
            formatter: params => Number(params.value) == 0 ? "" : `${Number(params.value).toFixed(1)}%`,
            color: darkStyleKeys.includes(style.key) ? "#ffffff" : "#000000",
            fontSize: 10,
            fontWeight: 700
          },
          data: rows.map(row => row[style.key] || 0)
        });
/*        
        if (index === 0) {
          salesWizardBarSeries.markLine = {
            silent: true,
            symbol: "none",
            label: { show: false },
            lineStyle: {
              color: "#666666",
              width: 1,
              type: "solid"
            },
            data: [
              rowBorderLines[0],
              rowBorderLines[rowBorderLines.length - 1]
            ]
          };
        }
*/
        return salesWizardBarSeries;
      });
      const pictorialSeries = styles.map(style => ({
        name: style.name,
        type: "pictorialBar",
        xAxisIndex: 1,
        yAxisIndex: 1,
        symbol: style.symbol || "bar",
        symbolSize: [14, 14],
        symbolOffset: [10, 0],
        itemStyle: {
          color: "#111111"
        },
        data: [
          {
            name: style.name,
            value: [style.name, 1]
          }
        ],
        silent: true,
        z: 5,
        tooltip: { show: true }
      }));
      return barSeries.concat(pictorialSeries);
    },
    saveTable(table) {
      this.$emit('save-table', table);
    },
    saveCriteria(criteria) {
      this.$emit('save-criteria', criteria);
    },
    processChart: function(runChart = false,value,eChartCriteria){
        if (runChart == true) {
            this.setData(value);
            this.eChartCriteria = JSON.parse(JSON.stringify(eChartCriteria));
            this.initChart();
            this.$emit('save-criteria',true);
            this.$emit('save-table');
        }
    },

  },
  watch: {}
};
</script>
